export function toggleLoader(show, infinite = false) {
    const loader = document.getElementById('gallery-loader');
    
    // Create SVG loader if it doesn't exist
    if (!loader.querySelector('svg')) {
        loader.innerHTML = `
            <svg viewBox="0 0 50 50">
                <circle cx="25" cy="25" r="20" fill="none" stroke-width="4"/>
            </svg>
        `;
    }
    
    if (show) {
        loader.classList.add('loading');
        if (infinite) {
            loader.classList.add('infinite-loading');
        }
    } else {
        loader.classList.remove('loading', 'infinite-loading');
    }
}

export function transitionPage(contentCallback, containerSelector = '#patients-container') {
    const container = document.querySelector(containerSelector);
    const galleryContainer = document.getElementById('gallery-procedures-container');
    
    // Remove all view-specific classes
    galleryContainer.classList.remove('gallery-home', 'gallery-listing', 'gallery-single');
    
    // Remove existing transition classes from content container
    container.classList.remove('is-visible', 'is-loaded');
    
    // Add base transition class if not present
    if (!container.classList.contains('gallery-page')) {
        container.classList.add('gallery-page');
    }
    
    // Execute the content update callback
    contentCallback();
    
    // Force a reflow to ensure the transition works
    void container.offsetWidth;
    
    // Add visible class to trigger fade in
    container.classList.add('is-visible');
    
    // Add loaded class after content is presumably rendered
    setTimeout(() => {
        container.classList.add('is-loaded');
    }, 50);
}

// Add new function to set gallery view
export function setGalleryView(view) {
    const galleryContainer = document.getElementById('gallery-procedures-container');
    galleryContainer.classList.remove('gallery-home', 'gallery-listing', 'gallery-single');
    galleryContainer.classList.add(`gallery-${view}`);
}

export function updateURL(params) {
    const url = new URL(window.location);
    url.search = ''; // Clear existing parameters
    
    // Always add procedureId first if it exists
    if (params.procedureId !== undefined && params.procedureId !== null) {
        url.searchParams.set('procedureId', params.procedureId);
    }
    
    // Then add other parameters
    for (const [key, value] of Object.entries(params)) {
        if (key !== 'procedureId' && value !== null && value !== undefined && !(key === 'page' && value === 1)) {
            url.searchParams.set(key, value);
        }
    }
    
    history.pushState({}, '', url);
}

export function scrollToGalleryTop() {
    const galleryContainer = document.getElementById('gallery-procedures-container');
    if (galleryContainer) {
        const offset = 100; // Offset from the top (adjust as needed)
        const elementPosition = galleryContainer.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
}

export function addNavigationButtons(text, proceedUrl, callback, container = null) {
    // Create navigation container if it doesn't exist
    let navigationContainer = document.querySelector('.gallery-navigation');
    if (!navigationContainer) {
        navigationContainer = document.createElement('div');
        navigationContainer.className = 'gallery-navigation';
    } else {
        navigationContainer.innerHTML = ''; // Clear existing content
    }

    // Create back button
    const backButton = document.createElement('button');
    backButton.textContent = text;
    backButton.className = 'btn btn--outline back-button';
    backButton.addEventListener('click', function(e) {
        e.preventDefault();
        callback();
    });

    // Create procedure button if URL exists
    let procedureButton;
    if (proceedUrl) {
        procedureButton = document.createElement('a');
        procedureButton.href = proceedUrl;
        procedureButton.textContent = 'View Procedure';
        procedureButton.className = 'btn btn--outline procedure-button';
    }

    // Create contact button
    const contactButton = document.createElement('a');
    contactButton.href = '/contact'; // Update this with your actual contact page URL
    contactButton.textContent = 'Contact Us';
    contactButton.className = 'btn contact-button';

    // Add buttons to container
    navigationContainer.appendChild(backButton);
    if (proceedUrl && procedureButton) {
        navigationContainer.appendChild(procedureButton);
    }
    navigationContainer.appendChild(contactButton);

    // Insert navigation into specified container or default sidebar
    const targetContainer = container || document.querySelector('.gallery-sidebar__inner');
    if (targetContainer) {
        targetContainer.appendChild(navigationContainer);
    }
}

export function getProcedureDetails(procedureId, callback) {
    let xhr = new XMLHttpRequest();
    xhr.open('POST', ajaxurl, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);
            if (response.success) {
                callback(response.data.isParent, response.data.procedureName);
            } else {
                console.error('Failed to get procedure details');
                callback(false, '');
            }
        }
    };
    xhr.send('action=get_procedure_details&procedure_id=' + procedureId);
}